import React from "react";
import { node } from "prop-types";

import * as S from "./styled";

export default function PseudoButton({ children, ...passThroughProps }) {
  return (
    <S.PseudoButton {...passThroughProps}>
      <S.PseudoButtonCopy {...passThroughProps}>{children}</S.PseudoButtonCopy>
    </S.PseudoButton>
  );
}

PseudoButton.propTypes = {
  children: node.isRequired
};
